import {createFeatureSelector, createSelector} from '@ngrx/store';
import {
    PROOF_OF_DELIVERY_FEATURE_KEY,
    State,
} from './proof-of-delivery.reducer';

// Lookup the 'ProofOfDelivery' feature state managed by NgRx
export const getProofOfDeliveryState = createFeatureSelector<State>(
    PROOF_OF_DELIVERY_FEATURE_KEY
);


export const getProofOfDeliveryLoaded = createSelector(
    getProofOfDeliveryState,
    (state: State) => state.loading
);

export const getProofOfDeliveryError = createSelector(
    getProofOfDeliveryState,
    (state: State) => state.error
);

export const getProofOfDelivery = createSelector(
    getProofOfDeliveryState,
    (state: State) => state.proofOfDelivery
);

export const hasOne = createSelector(
    getProofOfDeliveryState,
    (state: State) => state.hasOne
);
